export default function checkErrorIsUnrecognizedResponse(error, recognizedStatusErrors) {
  if (
    !error.response
    || !error.response.data
    || !error.response.status
    || !recognizedStatusErrors.includes(error.response.status)
  ) {
    return true;
  }

  return false;
}
